import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-[#0a0d0f] text-white overflow-x-hidden" }
const _hoisted_2 = { class: "mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 py-8 md:grid-cols-2 md:px-6 md:py-14" }
const _hoisted_3 = { class: "flex flex-col justify-center" }
const _hoisted_4 = { class: "mt-5 flex flex-wrap gap-3" }
const _hoisted_5 = { class: "lead-card-wrap" }
const _hoisted_6 = { class: "lead-card" }
const _hoisted_7 = { class: "md:col-span-2" }
const _hoisted_8 = { class: "md:col-span-2 grid grid-cols-1 gap-6 md:grid-cols-2" }
const _hoisted_9 = { class: "field-reset min-w-0" }
const _hoisted_10 = { class: "field-reset min-w-0" }
const _hoisted_11 = { class: "md:col-span-2 grid grid-cols-1 gap-6 md:grid-cols-2" }
const _hoisted_12 = { class: "field-reset" }
const _hoisted_13 = { class: "field-reset" }
const _hoisted_14 = { class: "md:col-span-2" }
const _hoisted_15 = { class: "md:col-span-2" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "bg-[#0b0f11] px-6 pb-10" }
const _hoisted_18 = { class: "mx-auto grid max-w-6xl grid-cols-1 gap-4 md:grid-cols-4" }
const _hoisted_19 = { class: "bg-[#0e1114] px-6 pb-10" }
const _hoisted_20 = { class: "mx-auto grid max-w-6xl grid-cols-1 gap-4 md:grid-cols-3" }
const _hoisted_21 = { class: "bg-[#0b0f11] px-6 py-10" }
const _hoisted_22 = { class: "mx-auto max-w-6xl" }
const _hoisted_23 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }

import { reactive, ref, defineComponent, h, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import LocationField from '@/components/search/LocationField.vue'
import DateField from '@/components/search/DateField.vue'
import TimeField from '@/components/search/TimeField.vue'
import { getBackendBaseUrl } from '@/utils/common'

/** Replace with your asset path if different */
import heroImageUrl from '@/assets/landing/airport-hero.jpg'

export default /*@__PURE__*/_defineComponent({
  __name: 'LandingPageAirportTransfer',
  setup(__props) {

const heroImage = heroImageUrl

const router = useRouter()
const submitting = ref(false)
const carTypeOptions = ['Premium', 'Luxury', 'SUV', 'Van']

const form = reactive({
  name: '',
  phone: '',
  email: '',
  pickup: '',
  dropoff: '',
  datetime: '',
  notes: '',
  // NEW
  carType: '',
  passengers: 0,
  suitcases: 0,
})

// Use the same shape your Home form expects
const pickUp = reactive({
  location: { id: '', name: '', isAirport: false, coordinates: { lat: null, lng: null } },
  date: null as string | null,
  time: '' as string
})
const dropOff = reactive({
  location: { id: '', name: '', isAirport: false, coordinates: { lat: null, lng: null } }
})

const onAddressSelected = (address: any, type: 'pickUp' | 'dropOff') => {
  const add = address ?? { id: '', name: '', coordinates: { lat: null, lng: null } }
  if (type === 'pickUp') {
    pickUp.location = add
    form.pickup = add?.name || add?.description || ''
  } else {
    dropOff.location = add
    form.dropoff = add?.name || add?.description || ''
  }
}
const onDateChanged = (d: string) => {
  pickUp.date = d
  form.datetime = [pickUp.date, pickUp.time].filter(Boolean).join(' ')
}
const onTimeChanged = (t: string) => {
  pickUp.time = t
  form.datetime = [pickUp.date, pickUp.time].filter(Boolean).join(' ')
}

const scrollToForm = () => {
  const els = document.querySelectorAll('form')
  if (els && els[0]) els[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const submitLead = async () => {
  // basic validation
  if (!form.name || !form.phone || !form.pickup || !form.dropoff || !form.datetime) {
    alert('Please fill all required fields.')
    return
  }
  if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) {
    alert('Please enter a valid email.')
    return
  }
  if (form.passengers < 0 || form.suitcases < 0) {
    alert('Passengers / Suitcases cannot be negative.')
    return
  }

  const API_BASE = getBackendBaseUrl() // e.g. https://vehitraworld.com/backend/public/
  const payload = {
    name: form.name,
    phone: form.phone,
    email: form.email || null,
    pickup: form.pickup,
    dropoff: form.dropoff,
    datetime: form.datetime,
    notes: form.notes || null,
    source: 'landing-airport-transfer',
    // NEW extra info for admin:
    car_type: form.carType || null,
    passengers: Number(form.passengers) || 0,
    suitcases: Number(form.suitcases) || 0,
    // optionally include structured objects
    pickUp,
    dropOff,
  }

  submitting.value = true
  try {
    const res = await fetch(`${API_BASE}api/leads/airport-transfer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    })
    if (!res.ok) {
      const msg = await res.text().catch(() => '')
      throw new Error(`Request failed (${res.status}) ${msg}`)
    }
    router.push({ name: 'ThankYou' })
  } catch (e: any) {
    alert(e?.message || 'Something went wrong while submitting your request.')
  } finally {
    submitting.value = false
  }
}

/* ---------- PAC dropdown patch (keeps your styling) ---------- */
function usePatchPacDropdown() {
  const getFocusedInput = (): HTMLInputElement | null =>
    document.activeElement?.tagName === 'INPUT'
      ? (document.activeElement as HTMLInputElement)
      : (document.querySelector('.lead-form input:focus') as HTMLInputElement | null)

  const apply = () => {
    const pacs = document.querySelectorAll<HTMLElement>('.pac-container')
    if (!pacs.length) return
    const input = getFocusedInput() || (document.querySelector('.lead-form input') as HTMLInputElement | null)
    if (!input) return
    const r = input.getBoundingClientRect()
    const desiredWidth = Math.max(r.width + 40, 560)
    pacs.forEach(pac => {
      pac.style.setProperty('position', 'fixed', 'important')
      pac.style.setProperty('left', `${r.left}px`, 'important')
      pac.style.setProperty('top', `${r.bottom}px`, 'important')
      pac.style.setProperty('width', `${desiredWidth}px`, 'important')
      pac.style.setProperty('minWidth', `${desiredWidth}px`, 'important')
      pac.style.setProperty('maxWidth', `${desiredWidth}px`, 'important')
      pac.style.setProperty('maxHeight', '480px', 'important')
      pac.style.setProperty('overflowY', 'auto', 'important')
      pac.style.setProperty('overflowX', 'hidden', 'important')
      pac.style.setProperty('zIndex', '99999', 'important')
      pac.style.setProperty('borderRadius', '12px', 'important')
      pac.style.setProperty('border', '1px solid rgba(255,255,255,.18)', 'important')
      pac.style.setProperty('background', 'rgba(15,19,23,.98)', 'important')
      pac.style.setProperty('boxShadow', '0 12px 40px rgba(0,0,0,.5)', 'important')
      pac.style.setProperty('padding', '4px 0', 'important')
    })
  }

  const onFocusIn  = () => setTimeout(() => { apply() }, 50)
  const onFocusOut = () => {}
  const onResize   = () => apply()
  const onScroll   = () => apply()

  onMounted(() => {
    document.addEventListener('focusin', onFocusIn, true)
    document.addEventListener('focusout', onFocusOut, true)
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onScroll, true)
    const mo = new MutationObserver(apply)
    mo.observe(document.body, { childList: true, subtree: true })
  })
  onBeforeUnmount(() => {
    document.removeEventListener('focusin', onFocusIn, true)
    document.removeEventListener('focusout', onFocusOut, true)
    window.removeEventListener('resize', onResize)
    window.removeEventListener('scroll', onScroll, true)
  })
}
usePatchPacDropdown()

/* ---------- Lightweight local components ---------- */
const Badge = defineComponent({
  name: 'Badge',
  props: { icon: String },
  setup(props, { slots }) {
    const iconMap: Record<string, string> = { lifebuoy: '🛟', smile: '🙂', plane: '✈️' }
    return () =>
      h('span',
        { class: 'inline-flex items-center gap-2 rounded-full bg-white/5 px-3 py-1 text-xs ring-1 ring-white/10' },
        [ h('span', { class: 'opacity-80' }, iconMap[props.icon || ''] || '•'), slots.default?.() ]
      )
  }
})

const TextField = defineComponent({
  name: 'TextField',
  props: { label: String, modelValue: [String, Number], placeholder: String, type: { type: String, default: 'text' }, min: [String, Number] },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) => emit('update:modelValue', e.target.value)
    return () => h('label', { class: 'block', ...attrs }, [
      h('div', { class: 'mb-1 text-[11px] text-white/70' }, props.label),
      h('input', {
        class: 'w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
        value: props.modelValue, placeholder: props.placeholder, onInput,
        type: props.type, min: props.min
      })
    ])
  }
})

const NumberField = defineComponent({
  name: 'NumberField',
  props: { label: String, modelValue: [String, Number], min: { type: [String, Number], default: 0 } },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) => emit('update:modelValue', e.target.value === '' ? '' : Number(e.target.value))
    return () => h('label', { class: 'block', ...attrs }, [
      h('div', { class: 'mb-1 text-[11px] text-white/70' }, props.label),
      h('input', {
        class: 'w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
        value: props.modelValue, type: 'number', min: props.min, onInput
      })
    ])
  }
})

const SelectField = defineComponent({
  name: 'SelectField',
  props: { label: String, modelValue: String, options: Array as () => string[], placeholder: String },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onChange = (e: any) => emit('update:modelValue', e.target.value)
    return () => h('label', { class: 'block', ...attrs }, [
      h('div', { class: 'mb-1 text-[11px] text-white/70' }, props.label),
      h('select', {
        class: 'w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none focus:border-white/30',
        value: props.modelValue ?? '',
        onChange
      }, [
        h('option', { value: '' }, props.placeholder || 'Select…'),
        ...(props.options || []).map(o => h('option', { value: o }, o))
      ])
    ])
  }
})

const TextArea = defineComponent({
  name: 'TextArea',
  props: { label: String, modelValue: String, placeholder: String },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) => emit('update:modelValue', e.target.value)
    return () => h('label', { class: 'block', ...attrs }, [
      h('div', { class: 'mb-1 text-[11px] text-white/70' }, props.label),
      h('textarea', {
        class: 'min-h-[90px] w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
        value: props.modelValue, placeholder: props.placeholder, onInput
      })
    ])
  }
})

const FeatureCard = defineComponent({
  name: 'FeatureCard',
  props: { title: String, copy: String },
  setup(props) {
    return () =>
      h('div', { class: 'rounded-2xl border border-white/10 bg-[#0f1317] p-5' }, [
        h('div', { class: 'text-[13px] font-semibold' }, props.title),
        h('p', { class: 'mt-2 text-sm text-white/70' }, props.copy)
      ])
  }
})

const Testimonial = defineComponent({
  name: 'Testimonial',
  props: { text: String, who: String },
  setup(props) {
    return () =>
      h('div', { class: 'rounded-2xl border border-white/10 bg-[#0f1317] p-5' }, [
        h('div', { class: 'mb-2 text-emerald-400' }, '★★★★★'),
        h('p', { class: 'text-sm text-white/85' }, `“${props.text}”`),
        h('div', { class: 'mt-3 text-xs text-white/50' }, props.who)
      ])
  }
})

const FAQ = defineComponent({
  name: 'FAQ',
  props: { q: String, a: String },
  setup(props) {
    const open = ref(false)
    const toggle = () => (open.value = !open.value)
    return () =>
      h('div', { class: 'overflow-hidden rounded-2xl border border-white/10 bg-[#0f1317]' }, [
        h('button', { class: 'flex w-full items-center justify-between px-4 py-4 text-left text-sm font-semibold', onClick: toggle },
          [ h('span', props.q), h('span', { class: (open.value ? 'rotate-90 ' : '') + 'transition' }, '▸') ]
        ),
        open.value && h('div', { class: 'px-4 pb-4 text-sm text-white/70' }, props.a)
      ])
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: "relative",
      style: _normalizeStyle({
        backgroundImage: `linear-gradient(rgba(10,13,15,.75), rgba(10,13,15,.75)), url(${_unref(heroImage)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      })
    }, [
      _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6\" data-v-42bd0491><div class=\"flex items-center gap-3\" data-v-42bd0491><span class=\"inline-block h-3 w-3 rounded-full bg-emerald-500\" data-v-42bd0491></span><span class=\"text-sm font-semibold\" data-v-42bd0491>Vehitra World</span></div><div class=\"text-[11px] opacity-80\" data-v-42bd0491>24/7 Support · +973 3214 1440</div></div>", 1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[12] || (_cache[12] = _createStaticVNode("<span class=\"mb-3 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-[11px] font-semibold text-emerald-300 ring-1 ring-white/15\" data-v-42bd0491> New <span class=\"text-white/80\" data-v-42bd0491>Airport Transfers • Chauffeur</span></span><h1 class=\"leading-tight\" data-v-42bd0491><span class=\"block text-4xl font-extrabold md:text-5xl\" data-v-42bd0491>Premium Airport</span><span class=\"block text-4xl font-extrabold md:text-5xl\" data-v-42bd0491>Transfers — <span class=\"text-emerald-400\" data-v-42bd0491>24/7</span></span><span class=\"mt-1 block text-4xl font-extrabold text-emerald-300 md:text-5xl\" data-v-42bd0491>Worldwide</span></h1><p class=\"mt-4 max-w-xl text-sm text-white/80 md:text-base\" data-v-42bd0491> Professional chauffeurs, flight monitoring, meet &amp; greet, and fixed upfront pricing. Get an instant quote now. </p>", 3)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Badge), { icon: "lifebuoy" }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("24/7 Support")
              ])),
              _: 1
            }),
            _createVNode(_unref(Badge), { icon: "smile" }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Meet & Greet")
              ])),
              _: 1
            }),
            _createVNode(_unref(Badge), { icon: "plane" }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Flight Monitoring")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-[20px] font-semibold" }, "Get Instant Quote", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mt-1 text-[12px] text-white/70" }, "We’ll call or WhatsApp you to confirm.", -1)),
            _createElementVNode("form", {
              onSubmit: _withModifiers(submitLead, ["prevent"]),
              class: "lead-form mt-5 grid grid-cols-1 gap-6 md:grid-cols-2"
            }, [
              _createVNode(_unref(TextField), {
                label: "Full Name*",
                placeholder: "e.g. John Doe",
                modelValue: form.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(TextField), {
                label: "Phone (with country code)*",
                placeholder: "+966 5X XXX XXXX",
                modelValue: form.phone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.phone) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(TextField), {
                  label: "Email",
                  placeholder: "name@company.com",
                  modelValue: form.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(LocationField, {
                    class: "field-reset af-loc",
                    layout: 'simple',
                    drive: 'distance',
                    hasError: false,
                    data: pickUp,
                    type: "pickUp",
                    label: "Pickup Location*",
                    onAddressSelected: _cache[3] || (_cache[3] = addr => onAddressSelected(addr, 'pickUp'))
                  }, null, 8, ["data"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(LocationField, {
                    class: "field-reset af-loc",
                    layout: 'simple',
                    drive: 'distance',
                    hasError: false,
                    data: dropOff,
                    type: "dropOff",
                    label: "Drop Location*",
                    onAddressSelected: _cache[4] || (_cache[4] = addr => onAddressSelected(addr, 'dropOff'))
                  }, null, 8, ["data"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(DateField, {
                    class: "field-reset af-dt",
                    layout: 'simple',
                    hasError: false,
                    data: pickUp.date,
                    onDateChanged: onDateChanged
                  }, null, 8, ["data"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(TimeField, {
                    class: "field-reset af-dt",
                    layout: 'simple',
                    hasError: false,
                    data: pickUp.time,
                    onTimeChanged: onTimeChanged
                  }, null, 8, ["data"])
                ])
              ]),
              _createVNode(_unref(SelectField), {
                class: "md:col-span-2 md:max-w-none",
                label: "Car Type",
                modelValue: form.carType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.carType) = $event)),
                options: carTypeOptions,
                placeholder: "Select car type"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(NumberField), {
                label: "Passengers",
                modelValue: form.passengers,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.passengers) = $event)),
                modelModifiers: { number: true },
                min: "0"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(NumberField), {
                label: "Suitcases",
                modelValue: form.suitcases,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.suitcases) = $event)),
                modelModifiers: { number: true },
                min: "0"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(TextArea), {
                  label: "Additional Notes (optional)",
                  placeholder: "Flight number, child seats, special requests...",
                  modelValue: form.notes,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.notes) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: submitting.value,
                  class: "btn-primary"
                }, _toDisplayString(submitting.value ? 'Submitting…' : 'Get Quote Now'), 9, _hoisted_16),
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mt-2 text-center text-[11px] text-white/60" }, " By submitting, you agree to be contacted about your booking request. ", -1))
              ])
            ], 32)
          ])
        ])
      ])
    ], 4),
    _cache[21] || (_cache[21] = _createStaticVNode("<section class=\"bg-[#0e1114] px-6 pb-6 pt-8\" data-v-42bd0491><div class=\"mx-auto max-w-6xl text-center\" data-v-42bd0491><span class=\"rounded-full bg-white/5 px-3 py-1 text-[11px] text-white/70 ring-1 ring-white/10\" data-v-42bd0491> Trusted by business travelers in 65,000+ destinations </span><div class=\"mt-3 text-sm text-white/60\" data-v-42bd0491>★★★★★ <span class=\"align-middle\" data-v-42bd0491>4.8/5 average rating</span></div></div></section>", 1)),
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_unref(FeatureCard), {
          title: "Professional Chauffeurs",
          copy: "Experienced, multilingual, trained in courtesy and safety."
        }),
        _createVNode(_unref(FeatureCard), {
          title: "Meet & Greet",
          copy: "We wait at arrivals with a name board, track your flight, adjust for delays."
        }),
        _createVNode(_unref(FeatureCard), {
          title: "Confirm your Quote",
          copy: "Confirm your quote before the ride."
        }),
        _createVNode(_unref(FeatureCard), {
          title: "24/7 Support",
          copy: "Always available for last-minute changes or special requests."
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_unref(Testimonial), {
          text: "Flawless airport pickup, courteous driver, clean SUV. Will book again.",
          who: "— Business Consultant, Riyadh"
        }),
        _createVNode(_unref(Testimonial), {
          text: "Impeccable meet & greet and smooth ride to hotel. Highly recommended.",
          who: "— Frequent Flyer, London"
        }),
        _createVNode(_unref(Testimonial), {
          text: "On time, flight delay managed perfectly. Excellent service.",
          who: "— Corporate Traveler, Dubai"
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "mb-6 text-xl font-semibold" }, "Frequently Asked Questions", -1)),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_unref(FAQ), {
            q: "Do you monitor flights?",
            a: "Yes. We track live flight information and adjust pickup time if your flight is delayed."
          }),
          _createVNode(_unref(FAQ), {
            q: "What’s your cancellation policy?",
            a: "Free cancellation for most bookings up to 24 hours before pickup unless stated otherwise."
          }),
          _createVNode(_unref(FAQ), {
            q: "Can I request child seats?",
            a: "Absolutely. Add the request in notes and we’ll confirm availability in your quote."
          }),
          _createVNode(_unref(FAQ), {
            q: "Which vehicles do you offer?",
            a: "Sedans, premium sedans, luxury, SUVs and vans. We’ll match your party and luggage."
          })
        ])
      ])
    ]),
    _createElementVNode("section", { class: "bg-[#0b0f11] px-6 pb-16" }, [
      _createElementVNode("div", { class: "mx-auto max-w-6xl text-center" }, [
        _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "text-2xl font-extrabold" }, "Your comfort, our priority.", -1)),
        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "mx-auto mt-2 max-w-xl text-white/70" }, " Book your airport transfer now and travel stress-free. ", -1)),
        _createElementVNode("button", {
          onClick: scrollToForm,
          class: "mt-5 inline-flex items-center justify-center rounded-full bg-emerald-500 px-6 py-3 font-semibold text-[#0a0d0f] transition hover:bg-emerald-400"
        }, " Get Instant Quote "),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mt-8 text-[11px] text-white/40" }, " © 2025 Vehitra World — Privacy • Terms • Contact ", -1))
      ])
    ])
  ]))
}
}

})